import type { ProdutoDetalhado } from '../hooks/useProdutosCampanha';

export const normalizeModalProductFromSearch = <T extends Partial<ProdutoDetalhado>>(product: T): T & { margin_price_retail?: number } => {
  if (product.margin_price_retail !== null && product.margin_price_retail !== undefined) {
    return product as T & { margin_price_retail?: number };
  }

  if (product.margin === null || product.margin === undefined) {
    return product as T & { margin_price_retail?: number };
  }

  return {
    ...product,
    margin_price_retail: product.margin * 100,
  };
};
